import React, { useEffect, useState } from 'react';
import { ASSET_URL } from '../../env/Configurations';
import './Custom-Image-Viewer.scss';
import { Dialog, DialogActions, DialogContent, Button } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';

const CustomImageViewer = (props) => {
  const { images, defaultImageSize, isLabelHidden = true, imageType = '' } = props;
  const [currentImage, setCurrentImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedRatio, setSelectedRatio] = useState('ratio1to1');
  const [defaultRatio, setDefaultRatio] = useState('ratio1to1');
  const [showImages, setShowImages] = useState([]);
  const [open, setOpen] = React.useState(false);
  const croppingRatios = ['1to1', '16to9', '21to9', '9to16', '9to21'];
  const NO_IMAGE_URL = '/assets/img/no-image-available/no-image-available.png';
  const fetchCompleteURLImages = (images) =>
    images.map((image) =>
      ['ratio1to1', 'ratio16to9', 'ratio21to9', 'ratio9to16', 'ratio9to21'].reduce(
        (acc, ratio) => ({
          ...acc,
          [ratio]: image[ratio] ? ASSET_URL + image[ratio] : NO_IMAGE_URL,
        }),
        {},
      ),
    );

  useEffect(() => {
    if (images) {
      setShowImages(fetchCompleteURLImages(images));
      if (
        defaultImageSize &&
        ['ratio1to1', 'ratio16to9', 'ratio21to9', 'ratio9to16', 'ratio9to21'].includes(
          defaultImageSize,
        )
      ) {
        setDefaultRatio(defaultImageSize);
      }
    }
  }, [images]);

  useEffect(() => {
    if (currentImage) {
      setPreviewImage(currentImage[selectedRatio]);
    }
  }, [selectedRatio, currentImage]);

  const handleClickOpen = (img) => {
    setCurrentImage(img);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const renderCroppingRatioButton = (ratio) => {
    const getButtonStyle = () => {
      switch (ratio) {
        case 'ratio1to1':
          return { width: '100px', height: '100px' };
        case 'ratio16to9':
          return { width: '178px', height: '100px' };
        case 'ratio21to9':
          return { width: '233px', height: '100px' };
        case 'ratio9to21':
          return { width: '45px', height: '100px' };
        case 'ratio9to16':
          return { width: '56px', height: '100px' };
        default:
          return {};
      }
    };

    return (
      <div className={`cropping-ratio-container cropping-ratio-${ratio}`} key={ratio}>
        <Button
          className={`cropping-ratio-${ratio}`}
          style={{
            ...getButtonStyle(),
            background: `url(${currentImage && currentImage[ratio]}) center/cover no-repeat `,
          }}
          color='secondary'
          variant={selectedRatio === ratio ? 'contained' : 'outlined'}
          onClick={() => setSelectedRatio(ratio)}
          autoFocus={selectedRatio === ratio}
        ></Button>
        <div className='cropping-ratio-text'>{ratio.slice(5).replace('to', ':')}</div>
      </div>
    );
  };

  const renderCroppingRatioButtons = () => (
    <div className='cropping-ratio-scroll horizontal-scroll-styled'>
      {croppingRatios?.map((ratio) => (
        <div className='cropping-ratio-container' key={ratio}>
          {renderCroppingRatioButton(`ratio${ratio}`)}
        </div>
      ))}
    </div>
  );

  return (
    <div className='custom-image-viewer'>
      <div className='row px-1'>
        {isLabelHidden ? (
          <h4 className='custom-image-viewer-title px-4'>
            {showImages?.length} {showImages?.length === 1 ? 'Image' : 'Images'}
          </h4>
        ) : null}
        {imageType ? <h4 className='custom-image-viewer-title px-4'>{imageType}</h4> : null}
        <div className='d-flex custom-image-viewer-gallery'>
          {showImages?.map((img, i) => (
            <div className='pt-2 image-custom' key={i}>
              <img
                src={img[defaultRatio]}
                alt='img'
                className='custom-image-viewer-card cursor-pointer'
                onClick={() => handleClickOpen(img)}
              ></img>
            </div>
          ))}
        </div>
      </div>

      <Dialog
        className='image-viewer'
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        maxWidth='lg'
      >
        <div className='image-viewer-left-wrapper page-builder-scroll scroll-styled'>
          <div className='d-flex flex-column justify-content-center'>
            <p className='image-viewer-dialogue-label'>Image preview</p>
            <div>
              <Cancel className='image-viewer-close' onClick={handleClose} />
            </div>
          </div>

          <DialogContent className='image-viewer-content'>
            <div className='d-flex image-viewer-scroll-image-list'>
              {/* Left side - Scrollable Image list */}
              <div className='page-builder-scroll scroll-styled me-4 image-viewer-list-container'>
                {showImages?.map((img, i) => (
                  <div className='m-4' key={i}>
                    <img
                      src={img[defaultRatio]}
                      alt='img'
                      className='custom-image-viewer-card custom-image-viewer-list-image cursor-pointer'
                      onClick={() => handleClickOpen(img)}
                    />
                  </div>
                ))}
              </div>
              {/* Right side - Selected image */}
              <div className='d-flex flex-column align-items-center image-viewer-custom-width'>
                <div className='image-viewer-container'>
                  {currentImage && (
                    <img
                      src={previewImage}
                      alt='img'
                      className='image-viewer-preview-img align-content-center'
                    />
                  )}
                </div>
                {/* action ratio  */}
                <div className='cropping-ratio'>
                  <DialogActions>
                    <div className='d-flex justify-content-center flex-column'>
                      {renderCroppingRatioButtons()}
                    </div>
                  </DialogActions>
                </div>
              </div>
            </div>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
};

export default CustomImageViewer;
